<script>
  import { EventBus } from '../../../services/event-bus-service';
  import { toggleItem,toggleAlgoItem, isOddActive, placeQuickBet, getQuickbetPlacementMessage } from '@bto-services/betslip-core';
  import { mapMatchToBetslipItem, mapMatchToBetslipMatchItem, BETSLIP_MSG_STATUS, getQuickBetClass } from 'bto-models/betslip';
  import { showBetslipValidation } from '@bto-services/modal';
  import { formatOddDisplay } from '@bto-services/utils';

  export default {
    name: 'MatchOddComponent',
    functional: true,
    render(createElement, context) {
      if (context.props.outcome.id < 0) {
        return;
      }
      /**
       * show combinability legend in the widget
       */
      if (context.props.odd && context.props.odd.isCombo > 1 && typeof context.parent.showCombinabilityLeg !== 'undefined') {
        context.parent.showCombinabilityLeg(true);
      }
      let getItemKeys = (props) => {
        if (`${props.outcome.id}`.startsWith('p-o')) {
          const matchId = props.match.matchId || props.match.id;
          let exploded = props.outcome.id.split('-');
          const outcomeId = +exploded[4];
          const marketId = +exploded[5];
          return {
            matchId,
            outcomeId,
            marketId,
          }
        }
        return {
          matchId: props.match.matchId || props.match.id,
          outcomeId: props.outcome.id,
          marketId: props.isOutright ? props.match.outcomeId : props.odd.marketId,
        }
      };

      const itemKey = getItemKeys(context.props);
      /**
       * Keep track if odd is selected
       */
      let isOddSelected = isOddActive(itemKey);

      const quickBetNotification = getQuickbetPlacementMessage(itemKey);

      function createQuickBetSpinner() {
        if (quickBetNotification && quickBetNotification.betslip.status === BETSLIP_MSG_STATUS.PENDING) {
          return createElement('div', { class: 'bto-sb-spinner-v1' });
        }
      }

      function createFormatedOddChildren() {
        const formatedOdd = formatOddDisplay(context.props.outcome.originalDecimalOutcome, context.parent.$root.oddFormat);
        const spinnerEl = createQuickBetSpinner();
        if (context.props.isLatam) {
          return [
            spinnerEl,
            createElement('i', null, `${context.props.oName} ${context.props.outcome.sbv || ''}`),
            createElement('i', null, formatedOdd),
          ];
        }
        if (context.props.isAgentPlayerMarket) {
          return [
            spinnerEl,
            createElement('i', null, formatedOdd),
          ];
        }
        if (spinnerEl) {
          return [spinnerEl, formatedOdd];
        }
        return [formatedOdd];
      }
      /**
       * Check if outcome is empty or 0
       */
      let checkInvalidOutcome = () => context.props.outcome.outcome === '--' ||
        context.props.outcome.originalDecimalOutcome === '--' ||
        parseFloat(context.props.outcome.originalDecimalOutcome) === 0 ||
        parseFloat(context.props.outcome.originalDecimalOutcome) === 1 ||
        context.props.outcome.id === 0 ||
        context.props.outcome.id === undefined;
      /**
       * Select or delete outcomes in match
       */
      let processOdd = (event) => {
        event.preventDefault();
        event.stopPropagation();
        EventBus.$emit("closeTooltip");
        if (!context.props.isOutright && !context.props.match.matchId) {
          return;
        }
        if (quickBetNotification) {
          return;
        }
        if (checkInvalidOutcome()) { return; }
        isOddSelected = !isOddSelected;
        const betslip_item = mapMatchToBetslipItem(
          context.props.match,
          context.props.outcome,
          context.props.odd,
          context.props.isOutright,
          true);
        const betslipMatchItem = mapMatchToBetslipMatchItem(context.props.match, context.props.isOutright);
        const error = toggleAlgoItem(betslip_item, betslipMatchItem);
        showBetslipValidation(error);
        if (isOddSelected) {
          placeQuickBet(betslip_item);
        }
      };
      /**
       * Show odd popup
       */
      let showOddPopup = (event) => {
        if (!APP_SETTINGS.settings.useOddTooltip) {
          return;
        }
        EventBus.$emit('showoddmarketpopup', {
          marketName: context.props.odd.enrichedMarketName || context.props.odd.marketName,
          outcome: context.props.outcome,
          e: event
        });
      };

      /**
       * Hide odd popup
       */
      let hideOddPopup = () => {
        if (!APP_SETTINGS.settings.useOddTooltip) {
          return;
        }
        EventBus.$emit('hideoddmarketpopup');
      };

      /**
       * Get the odd name  with concatanaited SBV  or just the name
       */
      let getOutcomeName = () => {
        return (context.props.outcome.enrichedOutcomeName || context.props.outcome.name) + createOtoiElem();
      };
      /**
       * If used on agent display identifiers for quick code betting
       */
      let createOtoiElem = () => {
        if (process.env.VUE_APP_IS_AGENT) {
          if (context.props.outcome.otoIdentifier) {
            return `<b class="bto-sb-extra-odd">[${context.props.outcome.otoIdentifier}]</b>`;
          }
        }
        return '';
      };

      /**
       * Create child elements
       */
      let createChildren = () => {
        const spinnerEl = createQuickBetSpinner();
        if (context.props.isOutright) {
          // DOM elements for outright
          return [
            spinnerEl,
            // outcome name
            !context.props.isDirectOutright && !context.props.isUsLayout && createElement('i', {
              domProps: {
                innerHTML: context.props.outcome.name,
              },
            }),
            // outcome index
            createElement('i', {
              domProps: {
                innerHTML: context.parent.$root.$options.filters.formatOddDisplay(context.props.outcome.outcome, context.parent.$root.oddFormat),
              },
            }),
          ];
        }
        // DOM elements for regular outcomes
        return [
          !context.props.isWincast && context.props.showTeamJerseys && context.props.outcome.teamEnum && createElement('div', {
            class: {
              'bto-sb-player-team-jersey': context.props.showTeamJerseys,
              'bto-sb-player-home': context.props.outcome.teamEnum === 1,
              'bto-sb-player-away': context.props.outcome.teamEnum === 2,
            }
          }),
          context.props.isPlayerMarket && createElement('div', {
            class: 'bto-sb-player-info',
          }, [
            createElement('div', { class: 'bto-sb-event-team' },
              [
                spinnerEl,
                createElement('i', null, `${getOutcomeName()}`),
                createElement('i', null, `${formatOddDisplay(context.props.outcome.originalDecimalOutcome, context.parent.$root.oddFormat)}`),
              ]),
            createElement('div', { class: 'bto-sb-event-description' }, `${context.props.showPlayerTeamName && context.props.playerTeamName || ''}`),
          ]),
          !context.props.isPlayerMarket && spinnerEl,
          !context.props.isPlayerMarket && !context.props.isWincast && createElement('i', {
            domProps: {
              innerHTML: getOutcomeName(),
            },
          }),
          !context.props.isPlayerMarket && createElement('i', {
            domProps: {
              innerHTML: context.parent.$root.$options.filters.formatOddDisplay(context.props.outcome.originalDecimalOutcome, context.parent.$root.oddFormat),
            },
          }),
        ];
      };
      /**
       * top level link element
       */

      // Check for "suspended" status
      const checkSuspendStatus = () => context.props.outcome.suspended
        || (context.props.match.suspended !== undefined && context.props.match.suspended)
        || (context.props.match.outrightSuspended !== undefined && context.props.match.outrightSuspended);

      if (context.props.isDetails === true) {
        return createElement('a', {
          class: [{
            'bto-sb-event-odd': true,
            'bto-sb-event-mormarket-market-odd-active': isOddSelected,
            'bto-sb-event-odd-active': isOddSelected, // ...
            'bto-sb-mormarket-odd-active': isOddSelected, // used in agent match details
            'bto-sb-odd-lock': (context.props.lockEmptyOdd && context.props.outcome.originalDecimalOutcome === '--') || checkSuspendStatus(),
            'bto-sb-odd-empty': context.props.outcome.originalDecimalOutcome === '--',
            'bto-sb-combomini': context.props.odd && context.props.odd.isCombo === 2,
            'bto-sb-combomini3': context.props.odd && context.props.odd.isCombo === 3,
            'bto-sb-combomini4': context.props.odd && context.props.odd.isCombo === 4,
            'bto-sb-combomini5': context.props.odd && context.props.odd.isCombo === 5,
          }, getQuickBetClass(quickBetNotification)],
          on: {
            click: e => {
              if (checkSuspendStatus()) return;
              processOdd(e);
            },
            mouseenter: e => {
              if (checkSuspendStatus()) return;
              showOddPopup(e);
            },
            mouseleave: e => {
              if (checkSuspendStatus()) return;
              hideOddPopup(e);
            },
          },
        }, createChildren());
      }
      if (context.props.isOutrightInDetails === true) {
        return createElement('a', {
          class: [{
            'bto-sb-event-odd': !process.env.VUE_APP_IS_AGENT,
            'bto-sb-event-mormarket-market-odd-active': isOddSelected,
            'bto-sb-event-odd-active': isOddSelected, // ...
            'bto-sb-mormarket-odd-active': isOddSelected, // used in agent match details
          }, getQuickBetClass(quickBetNotification)],
          on: {
            click: e => processOdd(e),
          },
        }, createChildren());
      }
      if (context.props.isOutright === true) {
        return createElement('span', {
          class: [{
            'bto-sb-event-outrights-odds-active': isOddSelected,
            'bto-sb-odd-lock': context.props.outcome.originalDecimalOutcome === '--' || checkSuspendStatus(),
          }, getQuickBetClass(quickBetNotification)],
          on: {
            click: e => {
              if (checkSuspendStatus()) return;
              processOdd(e);
            },
          },
        }, createChildren());
      }
      return createElement('span', {
        class: [{
          'bto-sb-event-odd': true,
          'bto-sb-event-odd-active': isOddSelected,
          'bto-sb-odd-lock': (context.props.outcome.originalDecimalOutcome === '--' && context.props.outcome.id > 0) || checkSuspendStatus(),
          'bto-sb-combomini': context.props.odd && context.props.odd.isCombo === 2,
          'bto-sb-combomini3': context.props.odd && context.props.odd.isCombo === 3,
          'bto-sb-combomini4': context.props.odd && context.props.odd.isCombo === 4,
          'bto-sb-combomini5': context.props.odd && context.props.odd.isCombo === 5,
        }, getQuickBetClass(quickBetNotification)],
        on: {
          click: e => {
            if (checkSuspendStatus()) return;
            processOdd(e);
          },
          mouseenter: e => {
            if (checkSuspendStatus()) return;
            showOddPopup(e);
          },
          mouseleave: e => {
            if (checkSuspendStatus()) return;
            hideOddPopup(e);
          },
        },
      }, createFormatedOddChildren());

      /**
       * end of top level link element
       */
    },
    props: {
      match: {
        type: Object,
        default: () => {
        },
        required: true,
      },
      outcome: {
        type: Object,
        default: () => {
        },
        required: true,
      },
      odd: {
        type: Object,
        default: () => {
        },
      },
      isOutright: {
        type: Boolean,
        default: false,
      },
      isPrematch: {
        type: Boolean,
        default: false,
      },
      isDetails: {
        type: Boolean,
        default: false,
      },
      lockEmptyOdd: {
        type: Boolean,
        default: true,
      },
      isDirectOutright: {
        type: Boolean,
        default: false,
      },
      isOutrightInDetails: {
        type: Boolean,
        default: false,
      },
      showTeamJerseys: {
        type: Boolean,
        default: false,
      },
      showPlayerTeamName: {
        type: Boolean,
        default: false,
      },
      isPlayerMarket: {
        type: Boolean,
        default: false,
      },
      playerTeamName: {
        type: String,
        default: '',
      },
      isLatam: {
        type: Boolean,
        default: false,
      },
      oName: {
        type: String,
        default: '',
      },
      isWincast: {
        type: Boolean,
        default: false,
      },
      isAgentPlayerMarket: {
        type: Boolean,
        default: false,
      },
      isUsLayout: {
        type: Boolean,
        default: false,
      }
    }
  };
</script>
